export const SET_COMPANY_PROFILE_DATA = 'SET_COMPANY_PROFILE_DATA';
export const SET_ORG_KEY = 'SET_ORG_KEY';
export const SET_MEMBERS_NETWORKS = 'SET_MEMBERS_NETWORKS';
export const SET_MEMBERS_NETWORK = 'SET_MEMBERS_NETWORK';
export const SET_COMPANY_LOCATIONS = 'SET_COMPANY_LOCATIONS';
export const SET_SOCIAL_MEDIA = 'SET_SOCIAL_MEDIA';
export const SET_COMPANY_ACTIVITIES = 'SET_COMPANY_ACTIVITIES';



// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/company/mutation-types.ts